import * as Sentry from '@sentry/react';

import deleteJSON from 'utilities/deleteJSON';
import { API_BASE_URL } from 'utilities/env';
import getJSON from 'utilities/getJSON';
import postJSON from 'utilities/postJSON';

import { getLeadId } from './leadId';

const getUrl = () => {
    const leadId = getLeadId();
    return `${API_BASE_URL}/Lead/${leadId}/Prescriptions`;
};

const addPrescription = async ({
    dosageID,
    ndc,
    metricQuantity,
    daysOfSupply,
    selectedPackage
}) => {
    const quantity = selectedPackage
        ? selectedPackage?.metricQuantity * metricQuantity
        : metricQuantity;

    const body = {
        dosageID,
        ndc,
        metricQuantity: quantity,
        daysOfSupply,
        selectedPackage
    };
    const url = getUrl();

    let response;
    try {
        response = await postJSON({ url, body });
    } catch (e) {
        Sentry.captureException(e);
    }
    return response;
};

const deletePrescription = async ({ id }) => {
    const url = `${getUrl()}/${id}`;
    let response;
    try {
        response = await deleteJSON({ url });
    } catch (e) {
        Sentry.captureException(e);
    }
    return response;
};

const getPrescriptions = async () => {
    let response = null;
    try {
        response = getJSON({ url: getUrl() });
    } catch (e) {
        Sentry.captureException(e);
    }
    return response;
};

export { addPrescription, deletePrescription, getPrescriptions };
